import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RaffleService from "service/Raffle";

export const getAllRaffleOcrActivities =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterCity: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_RAFFLE_OCR_ACTIVITY_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_RAFFLE_OCR_ACTIVITY",
      searchValue: search,
    });

    try {
      const data = await RaffleService.getAllRaffleOcrActivities(
        page,
        search,
        limit,
        filterCity
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_RAFFLE_OCR_ACTIVITY",
        value: data.raffle_ocr_activities,
      });

      dispatch({
        type: "SET_RAFFLE_OCR_ACTIVITY_PAGE",
        totalPage: !!data.raffle_ocr_activities.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.raffle_ocr_activities.length ? data.total_data : 1,
      });

      dispatch({
        type: "SET_RAFFLE_OCR_ACTIVITY_FILTER_PAGE",
        filterCityPage: filterCity,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
